import { render, staticRenderFns } from "./DepartmentEquipment.vue?vue&type=template&id=19c0466a"
import script from "./DepartmentEquipment.vue?vue&type=script&lang=js"
export * from "./DepartmentEquipment.vue?vue&type=script&lang=js"
import style0 from "./DepartmentEquipment.vue?vue&type=style&index=0&id=19c0466a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports